/**
 * How an audience input resolved, and the near-misses it left behind.
 *
 * The resolver answers with facts only. What to say about them depends on who
 * is reading — an AI host that must ask before picking, a card the person is
 * already looking at, a web picker — so each surface composes its own copy.
 */

export const MCP_AUDIENCE_STATUSES = [
  "resolved",
  "not-found",
  "archived",
  "private-no-access",
  "ambiguous",
] as const;

export type McpAudienceStatus = (typeof MCP_AUDIENCE_STATUSES)[number];

/** A near-miss to offer as a choice — never one to pick automatically. */
export interface McpAudienceCandidate {
  /** Slack id, so a caller can act on the choice without looking it up again. */
  id: string;
  name: string;
}
